import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import { Text } from '@beef/ui-kit';
import { Picture } from 'components';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);
const PICTURE_SCREEN_SIZE = 767;

const BannerFamily = ({ info, isSeb, children }) => {
  const pictureContent = [
    { image: info?.imageMobile, media: `(max-width: ${PICTURE_SCREEN_SIZE}px)` },
    { image: info?.imageDesktop },
  ];

  const fullTextOfDescription = useMemo(() => {
    if (isSeb) {
      return info?.descriptionSeb;
    }
    return info?.descriptionSdb;
  }, [info, isSeb]);

  return (
    <section className={cn('banner')}>
      <div className={cn('banner__content')}>
        {info.title && (
        <div className={cn('banner__title')}>
          <Text
            color="grey95"
            size="size3-m"
            tagType="h2"
          >
            {info.title}
          </Text>
        </div>
        )}
        <div className={cn('banner__description')}>
          {info.shortTextDescription && (
          <div className={cn('banner__description-short')}>
            <Text
              color="grey95"
              size="size5-r-s"
            >
              {info.shortTextDescription}
            </Text>
          </div>
          )}
          {fullTextOfDescription && (
          <div className={cn('banner__description-full')}>
            <Text
              color="grey95"
              size="size5-r-s"
            >
              {fullTextOfDescription}
            </Text>
          </div>
          )}
        </div>
        <div className={cn('banner__buttons')}>
          {children}
        </div>
      </div>
      <div className={cn('banner__picture')}>
        <Picture
          className={cn('banner__image')}
          content={pictureContent}
          defaultImage={info?.imageMobile}
          alt="семья с билайн"
        />
      </div>
    </section>
  );
};

BannerFamily.propTypes = {
  info: PropTypes.objectOf({
    descriptionSeb: PropTypes.string,
    descriptionSdb: PropTypes.string,
    shortTextDescription: PropTypes.string,
    imageMobile: PropTypes.string,
    imageDesktop: PropTypes.string,
  }),
  isSeb: PropTypes.bool,
};

export { BannerFamily };
